import { render, staticRenderFns } from "./ChargebackAudit.vue?vue&type=template&id=072e034c&scoped=true&"
import script from "./ChargebackAudit.vue?vue&type=script&lang=js&"
export * from "./ChargebackAudit.vue?vue&type=script&lang=js&"
import style0 from "./ChargebackAudit.vue?vue&type=style&index=0&id=072e034c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e034c",
  null
  
)

export default component.exports